import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import commonEn from "../translations/en/common.json";
import commonEt from "../translations/et/common.json";

i18n.use(initReactI18next).init({
    fallbackLng: process.env.NODE_ENV === "test" ? 'en' : 'et',
    saveMissing: false,

    load: 'currentOnly',
    debug: false,

    ns: ['common'],
    defaultNS: 'common',

    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            common: commonEn
        },
        et: {
            common: commonEt
        }
    },
});

export default i18n;